module.exports = __webpack_public_path__ + "resources/img/img_i_onenet2_jp.677bab06b0e7e887055a78a8177a9817.png";